import { DetailsDisplayMode, PaginationMode, SearchViewDisplayMode } from "@/user-preferences/enums";
import { extractColumnDisplayPreferences } from "@/lib/extract-columns-preferences";
import { teachers_column_display_seeds } from "./column-display-seeds";
import { GridColumnsPreset } from "@/user-preferences/enums";

export const teachersDefaultUserPreferences = {
    availableDisplayModes: [SearchViewDisplayMode.LIST, SearchViewDisplayMode.GRID, SearchViewDisplayMode.TABLE],
    detailsDisplayMode: DetailsDisplayMode.PANEL,
    table: {
        fontSize: 14,
        defaultItemsPerPage: 20,
        displayItemsPerPageSelector: true,
        paginationMode: PaginationMode.PAGED,
        verticalPadding: 14,
        zebraLines: true,
        showVerticalLines: true,
        showHorizontalLines: false,
        wrapText: false,
        columns: extractColumnDisplayPreferences(teachers_column_display_seeds),
    },
    grid: {
        masonryStyle: false,
        availableGridColumns: [
            GridColumnsPreset.AUTO_200,
            GridColumnsPreset.AUTO_250,
            GridColumnsPreset.AUTO_300,
            GridColumnsPreset.AUTO_400,
        ],
        gridColumns: GridColumnsPreset.AUTO_250,
    },
    viewCustom: {},
}
